import { render } from "./GeneralStatistics.vue?vue&type=template&id=7d7add5f&scoped=true"
import script from "./GeneralStatistics.vue?vue&type=script&lang=js"
export * from "./GeneralStatistics.vue?vue&type=script&lang=js"

import "./GeneralStatistics.vue?vue&type=style&index=0&id=7d7add5f&scoped=true&lang=css"

import exportComponent from "/var/www/likvio.se/html-prod/likvio-fe/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d7add5f"]])

export default __exports__